module.exports = __webpack_public_path__ + "static/img/6708_phase_function_Paper_PointsHejduk_Prediction.2aae032.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6708_phase_function_Paper_PointsHejduk_Prediction.png
// module id = sWY+
// module chunks = 0